module.exports = __webpack_public_path__ + "static/img/cus_05_pre.32465e0c.jpg";